export default {
    path: "portfolio",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "",
        name: "Portfolio Management",
        meta: {
          requiresAuth: true,
        },
        component: () => import("@/views/portfolio/portfolio.vue"),
      },
    //   {
    //     path: "unit-listing/:id",
    //     name: "Unit list",
    //     meta: {
    //       requiresAuth: true,
    //     },
    //     component: () => import("@/views/unit/unit.vue"),
    //   },
    //   {
    //     path: "updateUnitInfo/:id",
    //     name: "Update Unit Info",
    //     meta: {
    //       requiresAuth: true,
    //     },
    //     component: () => import("@/views/unit/updateUnitInfo.vue"),
    //   },
    ],
  };
  